/** WebSocket-клиент уведомлений поверх универсального `RealtimeSocket`.
 *
 *  Подключается к `/ws/notifications/`, передавая DRF-токен под-протоколом
 *  (см. `realtimeSocket.ts` и `apps/notifications/middleware.py`). Принимает
 *  события:
 *  * `{ type: 'notification.new', notification: {...} }`
 *  * `{ type: 'notification.resolved', id }`
 *  * `{ type: 'pong' }`
 *  Транспорт (reconnect/ping/heartbeat) живёт в `RealtimeSocket`; здесь — только
 *  путь, типизация событий и хелпер `markRead`.
 */
import { RealtimeSocket, type WsState } from "~/lib/realtimeSocket";
import type { Notification } from "~/lib/notifications";

export type { WsState };

export type WsServerEvent =
  | { type: "notification.new"; notification: Notification }
  | { type: "notification.resolved"; id: number }
  | { type: "pong" }
  | { type: "mark_read.ack"; id: number };

export interface NotificationsSocketOptions {
  /** Token из sessionStorage (DRF authtoken). */
  token: string;
  /** Базовый URL API — для построения ws:// из http://. Пустая строка = same-origin. */
  apiBaseUrl: string;
  onMessage: (event: WsServerEvent) => void;
  onStateChange?: (state: WsState) => void;
}

export class NotificationsSocket {
  private socket: RealtimeSocket;

  constructor(opts: NotificationsSocketOptions) {
    this.socket = new RealtimeSocket({
      token: opts.token,
      apiBaseUrl: opts.apiBaseUrl,
      path: "/ws/notifications/",
      onMessage: (event) => opts.onMessage(event as WsServerEvent),
      onStateChange: opts.onStateChange,
    });
  }

  getState(): WsState {
    return this.socket.getState();
  }

  connect(): void {
    this.socket.connect();
  }

  disconnect(): void {
    this.socket.disconnect();
  }

  send(payload: object): void {
    this.socket.send(payload);
  }

  markRead(id: number): void {
    this.socket.send({ type: "mark_read", id });
  }
}
